'use strict';

/**
 * @module comma-separate-number
 * @param  { int } val - the number to have commas inserted
 * @return { int } val - the newly created comma separated number
 */

module.exports = function (val) {
    // assign the regex to a variable to make it slightly easier to read
    var regex = /(\d+)(\d{3})/;

    // while the regex is true
    while (regex.test(val.toString())) {
        // insert a comma after every third number
        val = val.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    }

    //retrun the new number
    return val;
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/utilities/comma-separate-number.js
// module id = 211
// module chunks = 0